const openNewTab = (link: string) => {
  const win = window.open(link, "_blank");
  win!.focus();
};

export default openNewTab;
